import { getAppApiRoutes } from "../../Global";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class TerminalTypeService {
  async getTerminalTypes(): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminalType.getTerminalTypes, {});
  }
}

const service: TerminalTypeService = new TerminalTypeService();
export default service;
